import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import i18n from 'i18next';
import cx from 'classnames';
import { PAGESITS, PAGESITSFRONT } from '../consts/display';
import { create as createAuth } from '../utils/auth-helper';
var t = i18n.getFixedT(null, 'app');
var SideNavManu = /*#__PURE__*/React.memo(function (_ref) {
  var session = _ref.session,
      isManagementMode = _ref.isManagementMode,
      location = _ref.location,
      locale = _ref.locale,
      openSideMenu = _ref.openSideMenu,
      onMobileMenuClick = _ref.onMobileMenuClick,
      children = _ref.children;
  var rights = session.rights,
      menus = session.menus;
  var page_its = isManagementMode ? PAGESITS : PAGESITSFRONT;

  var rightAry = _.filter(rights, function (el) {
    if (isManagementMode) return el.indexOf('web.') === -1;
    return el.indexOf('evms.') === -1;
  });

  var menuAry = [];

  _.map(page_its, function (el, key) {
    var index = _.findIndex(menus, function (o) {
      return o.key === key;
    });

    if (index >= 0) menuAry.push(menus[index]);
  }); // _.filter(menus, el => el.key.indexOf('web.') === -1)


  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      menuList = _useState2[0],
      setMenuList = _useState2[1];

  var handleMobileMenuClick = function handleMobileMenuClick() {
    if (onMobileMenuClick) onMobileMenuClick();
  };

  var menuItems = _.keyBy(menuAry, 'key');

  var addChildren = function addChildren(parentKey, pages) {
    return _.map(_.drop(pages), function (key, index) {
      return {
        url: page_its[key].url,
        active: false,
        label: _.last(menuItems[parentKey].displayNames[index + 1].split('-'))
      };
    });
  };

  var getMenuList = function getMenuList() {
    var auth = createAuth(menuAry, page_its);
    return _.compact(_.map(auth.getMenu(rightAry), function (_ref2) {
      var key = _ref2.key,
          pages = _ref2.pages;
      if (!page_its[key]) return null;
      var obj = {
        url: page_its[key].url,
        active: false,
        label: _.last(menuItems[key].displayNames[0].split('-'))
      };

      if (pages.length > 1) {
        obj.openNode = true;
        obj.children = addChildren(key, pages);
      }

      return obj;
    }));
  };

  var translateLabel = function translateLabel(list) {
    var isChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return _.map(_.cloneDeep(list), function (el) {
      var keyArray = _.compact(_.split(el.url, '/'));

      var newLabel = !isChildren ? "menu.top.".concat(keyArray[0], ".title") : "menu.top.".concat(keyArray[0], ".").concat(keyArray[1]);
      el.label = t(newLabel);
      if (el.children) el.children = translateLabel(el.children, true);
      return el;
    });
  };

  var disableAllActive = function disableAllActive(list) {
    return _.map(list, function (el) {
      el.active = false;
      if (el.children) el.children = disableAllActive(el.children);
      return el;
    });
  };

  useEffect(function () {
    var newMenuList = menuList ? _.cloneDeep(menuList) : getMenuList();
    newMenuList = disableAllActive(newMenuList);

    var pathArray = _.compact(_.split(location.pathname, '/'));

    var targetItem = _.find(newMenuList, function (o) {
      return o.url === "/".concat(pathArray[0]);
    });

    if (pathArray.length > 1) targetItem = _.find(targetItem.children, function (o) {
      return o.url.indexOf(pathArray[1]) >= 0;
    });

    _.set(targetItem, 'active', true);

    setMenuList(newMenuList);
  }, [JSON.stringify(location)]);

  var handleOpenManuList = function handleOpenManuList(url) {
    var editManuList = _.cloneDeep(menuList);

    var targetItem = _.find(editManuList, function (o) {
      return o.url === url;
    });

    targetItem.openNode = !targetItem.openNode;
    setMenuList(editManuList);
  };

  var urlAndIcon = {
    '/map': /*#__PURE__*/React.createElement("i", {
      class: "fas fa-map-marked-alt urlIcon",
      title: t('menu.side.map.title')
    }),
    '/dashboard': /*#__PURE__*/React.createElement("i", {
      class: "fas fa-tachometer-alt urlIcon",
      title: t('menu.side.dashboard.title')
    }),
    '/logistic': /*#__PURE__*/React.createElement("i", {
      class: "fas fa-truck-moving urlIcon",
      title: t('menu.side.logistic.title')
    }),
    '/board': /*#__PURE__*/React.createElement("i", {
      class: "fas fa-calendar urlIcon",
      title: t('menu.side.board.title')
    }),
    '/event': /*#__PURE__*/React.createElement("i", {
      class: "fas fa-exclamation-triangle urlIcon",
      title: t('menu.side.event.title')
    }),
    // '/message': <i class="fas fa-comment-alt urlIcon" title={t('menu.side.message.title')}></i>,
    '/traffic': /*#__PURE__*/React.createElement("i", {
      class: "fas fa-chart-bar urlIcon",
      title: t('menu.side.traffic.title')
    }),
    '/user': /*#__PURE__*/React.createElement("i", {
      class: "fas fa-user-circle urlIcon",
      title: t('menu.side.user.title')
    }),
    '/setting': /*#__PURE__*/React.createElement("i", {
      class: "fas fa-cog urlIcon",
      title: t('menu.side.setting.title')
    })
  };

  var renderMenu = function renderMenu(menuList) {
    var isChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return _.map(menuList, function (el, index) {
      if (el.children) {
        return /*#__PURE__*/React.createElement("li", {
          key: el.url,
          className: "menu-item"
        }, /*#__PURE__*/React.createElement("span", {
          className: cx('menu-title'),
          onClick: function onClick() {
            return handleOpenManuList(el.url);
          }
        }, urlAndIcon[el.url], el.label, /*#__PURE__*/React.createElement("i", {
          className: cx('fas', el.openNode ? 'fa-caret-down' : 'fa-caret-right', 'trigger-icon')
        })), el.openNode && /*#__PURE__*/React.createElement("ul", {
          className: "sub-menu"
        }, renderMenu(el.children, true)), menuList.length - 1 !== index && /*#__PURE__*/React.createElement("div", {
          className: "hr-line"
        }));
      }

      return /*#__PURE__*/React.createElement("li", {
        key: el.url,
        className: cx(!isChildren ? 'menu-item menu-title' : 'sub-menu-item')
      }, /*#__PURE__*/React.createElement(Link, {
        to: {
          pathname: el.url
        },
        className: cx({
          'active': el.active
        }),
        onClick: handleMobileMenuClick
      }, urlAndIcon[el.url], /*#__PURE__*/React.createElement("span", {
        className: cx({
          'active': el.active
        })
      }, el.label)), !isChildren && /*#__PURE__*/React.createElement("div", {
        className: "hr-line"
      }));
    });
  };

  var renderChildren = function renderChildren(nodes) {
    return _.map(nodes, function (node) {
      return /*#__PURE__*/React.createElement("li", {
        className: cx({
          'active': node.active
        })
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
        onClick: handleMobileMenuClick,
        to: {
          pathname: node.url
        }
      }, node.label)));
    });
  };

  var renderNarrowMenu = function renderNarrowMenu() {
    return _.map(menuList, function (el, index) {
      if (el.children) {
        var isActive = _.filter(el.children, function (c) {
          return c.active === true;
        }).length > 0;
        return /*#__PURE__*/React.createElement("div", {
          key: el.url,
          className: cx('narrow-link', {
            'active': isActive
          })
        }, urlAndIcon[el.url], /*#__PURE__*/React.createElement("ul", null, renderChildren(el.children)));
      }

      return /*#__PURE__*/React.createElement(Link, {
        onClick: handleMobileMenuClick,
        to: {
          pathname: el.url
        }
      }, /*#__PURE__*/React.createElement("div", {
        key: el.url,
        className: cx('narrow-link', {
          'active': el.active
        })
      }, urlAndIcon[el.url]));
    });
  };

  if (_.isEmpty(menuList)) return null;

  if (!openSideMenu) {
    return /*#__PURE__*/React.createElement("div", {
      className: "narrow-side-menu"
    }, renderNarrowMenu());
  }

  return /*#__PURE__*/React.createElement("ul", {
    key: "g-side-menu",
    className: "g-side-menu"
  }, renderMenu(menuList), children ? children : null);
});
SideNavManu.propTypes = {
  session: PropTypes.object,
  location: PropTypes.object,
  locale: PropTypes.string,
  openSideMenu: PropTypes.bool
};
export default SideNavManu;